import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /kunden. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * kunden.index.tsx, Detail-/Form-Routen (kunden.$id.tsx, kunden.neu.tsx) werden ueber
 * den Outlet hier gerendert.
 *
 * Vorher hatte kunden.tsx selbst die Listen-Komponente — TanStack file-based
 * Routing hat sie aber als Parent fuer die Child-Routen erkannt. Ohne Outlet
 * sind Children nie gerendert; Klick auf "/kunden/neu" zeigte still die Liste.
 */
export const Route = createFileRoute('/kunden')({
  component: KundenLayout,
});

function KundenLayout() {
  return <Outlet />;
}
